
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
    },
  
    table: {
      backgroundColor: '#dcdcdc',
      padding: '1%',
      margin:'0.1%',
      overflowX:'auto'
    },
  
    items: {
      padding: '1%',
      display: 'flex',
      flexDirection: 'row',
      width:'100%'
    },
  
    item_header: {
      fontSize: '120%',
      fontWeight: 600,
      paddingLeft: '10%',
      width:'50%'
    },
  
    item_body: {
      padding: '6px ',
      width:'50%'
    },
  
    main_header: {
      padding: '1%',
      marginBottom: '3%',
      backgroundColor: '#32B6A7',
    },
  
    button_submit: {
      padding: '1%',
      justifyContent: 'center',
      display: 'flex',
      paddingTop: '6%',
    },
  
    input: {
      // width: '50%',
    },
  
    success: {
      textAlign: 'center',
      fontSize: '120%',
      fontWeight: 800,
    },
    cart_contents: {
      fontSize: '100%',
      textAlign: 'center',
      width:'100%',
      marginRight:'1%'
    },
    cart: {
      margin: '3%',
      border:'1px solid grey',
      backgroundColor:'white',
    },
    cart_header: {
      paddingLeft: '1.5%',
      color: '#32B6A7',
      fontSize: '130%',
      width:'100%',
      display:'flex',
      flexDirection:'row',
      marginBottom:'1%',
      paddingBottom:'2%',
      borderBottom: '1px solid #d5d8de'

    },
    cart_rows : {
      paddingLeft:'1.5%',
      display:'flex',
      flexDirection:'row'
    },
    booking : {
      padding: '1%',
      marginBottom:'1%',
      color: '#32B6A7',
      fontSize: '130%',
      borderBottom: '1px dashed',
    },
    icons : {
      display: 'flex',
      justifyContent: 'left',
    },
    button_cell : {
      justifyContent: 'space-evenly',
      display: 'flex',
      margin:'1%',
    },
    button : {
      backgroundColor: '#32B6A7',
      color:'black',
      display:'flex',
      justifyContent:'space-evenly',
    },
    total: {
      float:'right',
      padding:'1%',
      fontSize:'130%',
      color: '#32B6A7',
    },
    cart_item_image:{
      width:'20%'
    },
    cart_item_container:{
      display:'flex',
      flexDirection:'row'
    }
  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/partnerCourtBooking/style.js